import React from 'react';
export const CallToAction = () => {
  return <section className="mb-10" data-id="element-13">
      <h2 className="text-4xl font-bold mb-4" style={{
      color: '#465866'
    }} data-id="element-14">
        Why I'm Sharing This Publicly
      </h2>
      <p className="text-xl mb-4 italic" data-id="element-15">
        "I could have kept this discovery within my practice. But watching dog
        after dog transform made me realize: there are thousands of pets
        suffering on medications they don't need.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-16">
        The Pharmaceutical Problem:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-17">
        The pet pharmaceutical industry is worth billions. There's no financial
        incentive to promote drug-free alternatives, even when they work better.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-18">
        As a veterinarian, my oath is to 'first, do no harm.' I can no longer
        stay silent about a solution that works without side effects.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-19">
        What You Need to Know:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-20">
        If your dog is struggling with anxiety, you have options beyond
        medication. You deserve to know about ALL the tools available, not just
        the ones that generate prescription revenue.
      </p>
      <div className="mb-6" data-id="element-21">
        <p className="text-xl font-bold mb-2" data-id="element-22">
          For Dogs Currently on Medication:
        </p>
        <p className="text-xl mb-4 italic" data-id="element-23">
          PawEase can often be used alongside current medications (always
          consult your vet first). Many of my clients have successfully
          transitioned off medications entirely.
        </p>
      </div>
      <div className="mb-6" data-id="element-24">
        <p className="text-xl font-bold mb-2" data-id="element-25">For Dogs Not Yet Medicated:</p>
        <p className="text-xl mb-4 italic" data-id="element-26">
          Try this first. Give your dog's natural systems a chance to work
          before introducing pharmaceutical interventions.
        </p>
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-27">The Bottom Line</h3>
      <p className="text-xl mb-4 italic" data-id="element-28">
        Every day you wait is another day your dog suffers unnecessarily. And if
        you're considering medication - or already using it - you owe it to your
        dog to try the gentler approach first.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-29">
        Your dog deserves to be calm AND still be themselves.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-30">
        If Bailey could talk, I know what he'd tell anxious dogs everywhere:
        "There's hope. There's a way to feel safe without losing who you are."
      </p>
      <p className="text-xl mb-6 italic" data-id="element-31">
        Don't let your dog become another medicated statistic. Give them the
        chance to heal naturally, the way their bodies were designed to.
      </p>
      <p className="text-xl mb-6 italic font-bold" data-id="element-32">
        Because the greatest gift you can give an anxious dog isn't just calm -
        it's calm while still being completely, authentically themselves.
      </p>
      <div style={{
      backgroundColor: '#e9f0f3',
      borderColor: '#76a0b4'
    }} className="border-2 rounded-lg p-6 text-center mb-8" data-id="element-33">
        <div style={{
        backgroundColor: '#465866',
        transform: 'rotate(-3deg)'
      }} className="text-white font-bold text-3xl py-3 px-6 rounded-lg mb-6 inline-block mx-auto shadow-lg" data-id="element-34">
          SPECIAL OFFER: 50% OFF TODAY ONLY!
        </div>
        <h2 className="text-5xl font-bold mb-4" style={{
        color: '#465866'
      }} data-id="element-35">
          Get PawEase Risk-Free Today
        </h2>
        <p className="text-3xl mb-6" data-id="element-36">60-Day Money-Back Guarantee</p>
        <p className="text-xl italic mb-6" data-id="element-37">
          "Because every dog deserves to feel safe without losing who they are."
        </p>
        <p className="text-xl mb-4" data-id="element-38">- Dr. Sarah Chen, DVM</p>
        <a href="https://pawease2.myshopify.com/products/pawease" style={{
        backgroundColor: '#76a0b4'
      }} className="inline-block hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-full text-3xl mb-4" target="_blank" rel="noopener noreferrer" data-id="element-39">
          ORDER NOW - RISK FREE
        </a>
        <p className="text-lg text-gray-600" data-id="element-40">
          No prescription required. No side effects. Just natural calm.
        </p>
      </div>
    </section>;
};